import React, { useState } from 'react';
import posed from 'react-pose';
import styled, { css } from 'styled-components/macro';
import { theme } from 'Ui';

const color = theme.light.colors;
const ContainerInformationCard = styled.div`
  background: transparent;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const ContainerChildren = styled.div`
  color: var(--design-text-color);
`;

const Title = styled.div`
  display: flex;
  color: var(--design-text-color);
  font-family: var(--font-primary);
  font-size: 1.4rem;
  font-weight: 700;
  text-transform: uppercase;
`;

type InformationCard = {
  title?: React.ReactNode;
  children: React.ReactNode;
};

export const InformationCard = ({ title, children }: InformationCard) => {
  return (
    <ContainerInformationCard>
      <Title>{title}</Title>
      <ContainerChildren>{children}</ContainerChildren>
    </ContainerInformationCard>
  );
};
